import { NavLink, Outlet } from "react-router-dom";

const TABS = [
  { to: "company", label: "Firemní profil" },
  { to: "travel", label: "Doprava" },
  { to: "emails", label: "E-mailové schránky" },
];

export default function Settings() {
  return (
    <div>
      <h1 className="text-2xl font-bold text-slate-900">Nastavení</h1>
      <p className="mt-1 text-slate-600">Konfigurace aplikace — firemní údaje, ceny, integrace.</p>

      {/* Taby */}
      <div className="mt-6 border-b border-slate-200">
        <nav className="flex gap-1 overflow-x-auto">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              className={({ isActive }) =>
                `whitespace-nowrap border-b-2 px-4 py-2 text-sm font-medium transition ${
                  isActive
                    ? "border-obloha-indigo-700 text-obloha-indigo-800"
                    : "border-transparent text-slate-500 hover:text-slate-800"
                }`
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
      </div>

      <div className="mt-6">
        <Outlet />
      </div>
    </div>
  );
}
